import "./OurServices.module.css";
import Header from "@/reusable_sections/Header";
import OurServices from "./sections/OurServices";
import ConfiguratorHighlights from "./sections/ConfiguratorHighlights";
import CooperationProcess from "./sections/CooperationProcess";
import FinalCallToAction from "./sections/FinalCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function OurServicesPage() {
  return <div>
      <Header />
      <OurServices />
      <CooperationProcess />
      <ConfiguratorHighlights />
      <FinalCallToAction />
      <Footer />
    </div>;
}